// extracted by mini-css-extract-plugin
module.exports = {"root":"_36Q34","image":"_3SbkU","imageResponsive":"_3W6QE"};